import {
  Box,
  CircularProgress,
  Alert,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
} from '@mui/material';
import type { MiseSellerGroup } from '@/lib/types/mise/seller';

interface SellerGroupListProps {
  sellerGroups: MiseSellerGroup[] | undefined;
  isLoading: boolean;
  error: Error | null;
  title?: string;
}

export function SellerGroupList({ sellerGroups, isLoading, error, title }: SellerGroupListProps) {
  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 4 }}>
        <CircularProgress />
        <Typography sx={{ ml: 2 }}>読み込み中...</Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Alert severity="error" sx={{ mt: 2 }}>
        {error instanceof Error ? error.message : '店舗グループ一覧の読み込みに失敗しました。'}
      </Alert>
    );
  }

  if (!sellerGroups || sellerGroups.length === 0) {
    return (
      <Alert severity="info" sx={{ mt: 2 }}>
        店舗グループが登録されていません。
      </Alert>
    );
  }

  return (
    <Box sx={{ mt: 2 }}>
      {title && (
        <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, color: 'text.primary' }}>
          {title}
        </Typography>
      )}
      <TableContainer component={Paper} variant="outlined">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: 600 }}>店舗グループID</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>店舗グループ名</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sellerGroups.map((group) => (
              <TableRow key={group.id} hover>
                <TableCell sx={{ wordBreak: 'break-all' }}>{group.id}</TableCell>
                <TableCell>{group.name ?? ''}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
        全{sellerGroups.length}件
      </Typography>
    </Box>
  );
}
